module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/214-malawi-42e3fb61c0051d2e646c3f5f51d063d8.svg";